/*
 * @Author: Chris 
 * @Date: 2022-07-29 10:34:00 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-14 09:47:38
 */

<template>
  <el-drawer
    size="25%"
    :visible.sync="this.$store.state.Drawer_Department_Edit"
    :with-header="false"
    :modal="false"
    :before-close="closeDrawer"
    @open="opendrawer"
  >
    <div class="drawer">
      <div class="drawer_header">
        <div class="header_title">
          编辑部门
          <div class="bgIMg"></div>
        </div>
        <i class="el-icon-close" @click="closeDrawer"></i>
      </div>
      <div class="drawer_body">
        <div class="body_input">
          <div class="input_name"><span class="Required">*</span>部门名称</div>
          <el-input
            class="input_input"
            v-model="nameinput"
            placeholder="请输部门名称"
          ></el-input>
        </div>
        <div class="body_input">
          <div class="input_name"><span class="Required">*</span>上级部门</div>
          <el-input
            readonly
            class="input_input"
            v-model="superior.deptPName"
            @focus="chooseDepartment"
          ></el-input>
        </div>

        <div class="bottom_button">
          <div class="buttom_Del_line" @click="deletedepartment">删除部门</div>
          <div class="buttom_Del marin_l" @click="onSubmit">确定</div>
          <!-- <div class="buttom_Del_ban marin_l">确定</div> -->
        </div>
      </div>
    </div>
    <TreeDialog :deptId="companyData.deptId" :nowChoose="superior" @company-handler="chooseorg"></TreeDialog>
  </el-drawer>
</template>

<script>
import {
  authdept,
  authdeptupdate,
  authdeptmobile,
  authdeptdetails,
} from "../../../api/api";
import TreeDialog from "./dialogTree.vue";
export default {
  name: "EditDepartmentInformation",
  props: ["choosecompanyMsg"],
  components: { TreeDialog },
  mounted() {},
  data() {
    return {
      companyData: {},
      nameinput: "", //公司的名称
      changeTo: null, //要去的部门
      superior: {}, //上级部门
    };
  },

  watch: {},

  methods: {
    /**
     * 抽屉打开时，回显值
     * */

    async opendrawer() {
      this.companyData = { ...this.$props.choosecompanyMsg };
      await this.getauthdeptdetails();
      this.nameinput = this.companyData.deptName
        ? this.companyData.deptName.replace(/\(.*?\)/g, "")
        : "";
    },

    getauthdeptdetails() {
      let params = {
        deptId: this.companyData.deptId,
      };
      return authdeptdetails(params).then((res) => {
        this.superior = res.data;
      });
    },

    /**
     * 点击选择部门
     * */

    chooseDepartment() {
      this.$store.commit("SET_Dialog_Division_ChangeUpper", true);
    },

    /**
     * 选择部门回调
     * */

    async chooseorg(e) {
      await this.getauthdeptdetails();
      this.nameinput = this.companyData.deptName
        ? this.companyData.deptName.replace(/\(.*?\)/g, "")
        : "";
    },

    /**
     * 删除部门
     * */

    deletedepartment() {
      this.$confirm("是否确定删除该部门及其成员?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          deptIds: this.companyData.deptId,
        };
        authdept(params).then((res) => {
          if (res.code == 200) {
            this.closeDrawer();
            this.$store.commit("SET_Refresh_Organize");
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
          }
        });
      });
    },

    /**
     * 点击提交
     * */
    onSubmit() {
      if (this.nameinput) {
        let params = {
          id: this.companyData.deptId,
          companyName: this.nameinput,
          type: "dept",
        };
        authdeptupdate(params).then((res) => {
          if (res.code == 200) {
            if (!this.changeTo) {
              this.closeDrawer();
              this.$store.commit(
                "SET_EditDepartmentInformation",
                this.companyData.deptId
              );
              this.$store.commit("SET_Refresh_Organize");
              this.$notify.success({
                title: "成功",
                message: res.msg,
              });
            }
          }
        });
      }
      if (this.changeTo) {
        if (this.changeTo.deptId != this.companyData.deptId) {
          let params = {
            deptId: this.companyData.deptId,
            targetDeptId: this.changeTo.deptId,
          };
          authdeptmobile(params).then((res) => {
            if (res.code == 200) {
              if (this.changeTo) {
                this.closeDrawer();
                this.$store.commit("SET_Refresh_Organize");
                this.$notify.success({
                  title: "成功",
                  message: res.msg,
                });
              }
            }
          });
        } else {
          this.$notify.error({
            title: "错误",
            message: "不能选择本部门为上级部门",
          });
        }
      }
    },

    /**
     * 关闭抽屉
     * */

    closeDrawer() {
      this.$store.commit("SET_Drawer_Department_Edit", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer {
  width: 100%;
  display: flex;
  flex-direction: column;
  .bottom_button {
    bottom: 2rem;
    position: absolute;
    display: flex;
  }
  .marin_l {
    margin-left: 0.75rem;
  }
  .drawer_header {
    cursor: pointer;
    user-select: none;
    border-bottom: 0.125rem solid #eeeeee;
    height: 3.375rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.25rem;
    box-sizing: border-box;
    .header_title {
      font-weight: 400;
      font-size: 1rem;
      position: relative;
      .bgIMg {
        position: absolute;
        bottom: 0;
        left: -0.5rem;
        width: 6.25rem;
        height: 0.625rem;
        background: linear-gradient(
          90deg,
          rgba(183, 40, 45, 0.3) 0%,
          rgba(183, 40, 45, 0.018) 99.4%
        );
        border-radius: 0.5rem;
      }
    }
  }
  .drawer_body {
    display: flex;
    flex-direction: column;
    align-items: center;
    .body_img {
      width: 5.5rem;
      height: 5.5rem;
      border-radius: 0.25rem;
      margin-top: 2rem;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .body_input {
      margin-top: 1.875rem;
      display: flex;
      font-weight: 400;
      font-size: 0.75rem;
      line-height: 2.5rem;
      .input_name {
        width: 80px;
      }
      .input_input {
        width: 18.75rem;
      }
    }

    .body_bottom {
      display: flex;
      margin-top: 6.25rem;
      user-select: none;
      cursor: pointer;

      .body_conf {
        width: 4rem;
        height: 2rem;
        background: #b7282d;
        border-radius: 0.25rem;
        color: #ffffff;
        font-size: 0.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 1.875rem;
      }
      .body_delete {
        background: #ffffff;
        color: #b7282d;
        font-weight: 400;
        font-size: 0.75rem;
        line-height: 1.25rem;
        border: 0.0625rem solid #b7282d;
        border-radius: 0.25rem;
        height: 2rem;
        width: 5rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>